<template>
  <img src="@/assets/images/icons/close-menu-pb.svg" alt="close">
</template>

<script>
export default {
  name: 'IconClosePopup'
}
</script>
